import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]

  connect() {
    // Ensure menu is hidden on connect
    this.close()
  }

  toggle() {
    if (this.menuTarget.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Show overlay
    this.overlayTarget.classList.remove("hidden")

    // Slide in menu
    setTimeout(() => {
      this.menuTarget.classList.remove("translate-x-full")
      this.menuTarget.classList.add("translate-x-0")
    }, 10)

    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }

  close() {
    // Slide out menu
    this.menuTarget.classList.remove("translate-x-0")
    this.menuTarget.classList.add("translate-x-full")

    // Hide overlay after animation
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
    }, 300)

    // Re-enable body scroll
    document.body.style.overflow = ""
  }

  disconnect() {
    // Clean up when controller is disconnected
    document.body.style.overflow = ""
  }
}
